import { Box, Typography } from "@mui/material";
import React from "react";
import { getStatusStyles } from "../../../../config/constant";

const PaymentCard = ({ amount, date, method, status, transactionId }) => {
  const { bg, color, text, icon } = getStatusStyles(status);

  return (
    <Box
      sx={{
        border: "1px solid rgba(26, 64, 125, 0.3)",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: { xs: '8px 6px', sm: '12px 6px' }, // smaller padding on phones
        mb: 2,
        flexDirection: { xs: "column", sm: "row" }, // stack on small screens
        gap: { xs: 1.5, sm: 0 }, // spacing between stacked items
      }}
    >
      {/* Left side: Icon + Amount stacked with Date */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: { xs: "100%", sm: "auto" },
        }}
      >
        <img
          src={icon}
          alt={`${status}-icon`}
          style={{ marginRight: 8, marginTop: 2 }}
        />
        <Box>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: { xs: "14px", sm: "16px" },
            }}
          >
            {amount}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "14px" },
              fontWeight: 500,
              color: "rgba(0,0,0,0.6)",
            }}
          >
            {transactionId ? transactionId : ""} • {date} • {method}
          </Typography>
        </Box>
      </Box>

      {/* Right side: Status Badge */}
      <Box
        sx={{
          mt: { xs: 1, sm: 0 }, // add spacing when stacked
          alignSelf: { xs: "flex-start", sm: "center" }, // left align badge on small
          backgroundColor: bg,
          color,
          borderRadius: "6px",
          px: 1.5,
          py: 0.5,
          fontWeight: 700,
          fontSize: { xs: "12px", sm: "14px" },
          ml:'3px'
          
        }}
      >
        {text}
      </Box>
    </Box>
  );
};

export default PaymentCard;